<script>
export default {
  props: {
    title: { type: String, default: null },
    subtitle: { type: String, default: null },
    loader: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div />
</template>
